import React from "react";
import { Outlet } from "react-router-dom";

export const Root = () => {
  return (
    <>
      <div className="flex flex-1 flex-col w-full h-screen">
        <div className="flex-1">
          <Outlet />
        </div>
      </div>
    </>
  );
};
